import * as sup from 'superstruct';

export const SUPPLIER_LANGUAGES = ['en', 'sv', 'no'] as const;
export const supplierLanguageStruct = sup.enums(SUPPLIER_LANGUAGES);
export type SupplierLanguageType = sup.Infer<typeof supplierLanguageStruct>;
